import React from 'react'

const BuyersGuideContext = React.createContext()

export const BuyersGuideProvider = ({ state, children }) => (
  <BuyersGuideContext.Provider value={state}>{children}</BuyersGuideContext.Provider>
)

const useBuyersGuide = () => React.useContext(BuyersGuideContext)

export default useBuyersGuide
